@app.directive 'higherLogicComments', ($window, csConfig) ->
  restrict: 'E'
  scope: {
    vanillaIdentifier: '='
  }

  link: ($scope, element, attrs) ->
    $scope.showSignInGateway = false
    messageHandler = null

    installComments = ->
      # Validate vanillaIdentifier is present
      unless $scope.vanillaIdentifier
        console.error "vanillaIdentifier is not available"
        return

      # Environment-based forum config mapping
      forumUrlMapping = {
        'staging':    { url: 'https://uat-community.chefsteps.com/', categoryId: 16 }
        'production': { url: 'https://community.chefsteps.com/',     categoryId: 22 }
      }

      # Get forum config based on current environment
      forumConfig = forumUrlMapping[csConfig.env]

      # Check if community is configured for this environment
      unless forumConfig
        console.warn "Higher Logic community is not configured for environment: #{csConfig.env}"
        return

      vanillaForumUrl = forumConfig.url

      # Set global variables required by Vanilla embed script
      $window.vanilla_forum_url = vanillaForumUrl
      $window.vanilla_discussion_id = $scope.vanillaIdentifier
      $window.vanilla_category_id = forumConfig.categoryId

      # Build the sign-in URL with return target so user lands back here after login
      $scope.signinUrl = "#{vanillaForumUrl}entry/signin?Target=#{encodeURIComponent($window.location.href)}"

      # Listen for postMessage from the Higher Logic iframe.
      # When the iframe detects the user has a chefstepsSession cookie but is not
      # logged into the community, it sends REDIRECT_TO_SIGNIN — we show the gateway.
      messageHandler = (event) ->
        forumOrigin = vanillaForumUrl.replace(/\/$/, '')
        return unless event.origin == forumOrigin
        if event.data?.type == 'REDIRECT_TO_SIGNIN'
          $scope.$apply ->
            $scope.showSignInGateway = true

      $window.addEventListener 'message', messageHandler

      # Create and append the Vanilla embed script
      vanillaScript = document.createElement('script')
      vanillaScript.type = 'text/javascript'
      timestamp = new Date().getTime()
      vanillaScript.src = "#{vanillaForumUrl}/js/embed.js"

      # Append script to head or body
      (document.getElementsByTagName('head')[0] or document.getElementsByTagName('body')[0]).appendChild(vanillaScript)

      # Add loading class and observe for when the vn-loading div is removed
      vanillaCommentsEl = document.getElementById('vanilla-comments')
      if vanillaCommentsEl
        vanillaCommentsEl.classList.add('comments-loading')
        observer = new MutationObserver (mutations) ->
          for mutation in mutations
            for node in mutation.removedNodes
              if node.classList and node.classList.contains('vn-loading')
                vanillaCommentsEl.classList.remove('comments-loading')
                observer.disconnect()
                return
        observer.observe(vanillaCommentsEl, { childList: true })

    $scope.$on '$destroy', ->
      if messageHandler
        $window.removeEventListener 'message', messageHandler

    $scope.$watch 'vanillaIdentifier', (newValue, oldValue) ->
      if newValue
        installComments()

  templateUrl: "/assets/templates/components/higherLogicComments/higherLogicComments.html"
